export default __webpack_public_path__ + "static/media/PMR-Sunset-Round-700px.jpg.cde8b045.webp";